import { Errors } from '@/constants/errors';
import { stripeService } from '@/services/stripe';
import { PaymentMethodEnum } from '@/types/common';
import type { ICheckoutContext } from '@/types/context';
import { buildStripeGenericPaymentRequest } from '@/utils/stripe';
import { logError } from '@/utils/logger';

// BLIK_CHECKOUT bypasses Stripe's PaymentElement: `StripeDirectPayForm`
// renders no element and submits via `runPayment({ type })` only. We invoke
// BLIK through Stripe's P24 PaymentMethod API by hardcoding `p24.bank: 'blik'`
// — this shape MUST NOT change without product sign-off; it's how BLIK is
// onboarded through Stripe today (no native BLIK PaymentElement exists for
// non-PL accounts). Every other Stripe APM goes through
// `handleGenericStripePayment` (PaymentElement-driven).
export const handleBlikCheckoutPayment = async (
  checkout: ICheckoutContext,
  sendPaymentToServer: <TResponse>(params: unknown) => Promise<TResponse>
): Promise<unknown> => {
  try {
    const paymentMethodSettings = checkout.paymentMethodsSettings.find(
      (pm) => pm.paymentMethodName === PaymentMethodEnum.BLIK_CHECKOUT
    );
    if (!paymentMethodSettings) {
      throw new Error(Errors.payment.paymentFailed);
    }

    const stripePaymentMethod = await stripeService.createGenegicStripePaymentMethod({
      type: 'p24',
      billing_details: {
        email: checkout.customer.email ?? '',
      },
      p24: { bank: 'blik' },
    });

    return await sendPaymentToServer(
      buildStripeGenericPaymentRequest(stripePaymentMethod, paymentMethodSettings, checkout.customer)
    );
  } catch (error) {
    logError(Errors.payment.paymentFailed, error);
  }
};
